var _style, _rect, _line, _path, _polygon, _polygon2, _path2, _line2, _line3, _rect2, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmokeDetectorwithAlarm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st0",
    width: 15,
    height: 15
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 15.5,
    x2: 15.5,
    y2: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.5,15.5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13,11.8 12.4,12.4 13.6,12.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "11.3,13.2 10.7,13.8 11.9,14.3 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.7,13.2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.3,
    y1: 13.8,
    x2: 8,
    y2: 10.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 12.3,
    x2: 9.7,
    y2: 8.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 4.1,
    className: "st0",
    width: 1,
    height: 1.9
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.6,4.1 5.1,2.6 5.2,7.3 3.5,5.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokeDetectorwithAlarm);
export default __webpack_public_path__ + "static/media/SmokeDetectorwithAlarm.2b96ba954b9db867172554b60ac0563d.svg";
export { ForwardRef as ReactComponent };